import { FaSearch, FaMobileAlt, FaLink } from 'react-icons/fa';
import { SiGoogleanalytics } from 'react-icons/si';

type MetricCardProps = {
  title: string;
  value: string;
  change: string;
  isPositive: boolean;
  icon: React.ReactNode;
  description: string;
};

const MetricCard = ({ title, value, change, isPositive, icon, description }: MetricCardProps) => (
  <div className="rounded-lg bg-white p-6 shadow">
    <div className="flex items-center justify-between">
      <div>
        <p className="text-sm font-medium text-gray-500">{title}</p>
        <div className="mt-1 flex items-baseline">
          <p className="text-2xl font-semibold text-gray-900">{value}</p>
          <span className={`ml-2 flex items-center text-sm font-medium ${isPositive ? 'text-green-600' : 'text-red-600'}`}>
            {isPositive ? (
              <svg className="h-4 w-4" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M12 7a1 1 0 01-1.707-.707L10 6.586 7.707 8.879a1 1 0 11-1.414-1.414l3-3a1 1 0 011.414 0l3 3A1 1 0 0112 7z" clipRule="evenodd" />
              </svg>
            ) : (
              <svg className="h-4 w-4" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M12 13a1 1 0 01-.707-.293L10 11.414l-1.293 1.293a1 1 0 01-1.414-1.414l3-3a1 1 0 011.414 0l3 3a1 1 0 01-.707 1.707z" clipRule="evenodd" />
              </svg>
            )}
            {change}
          </span>
        </div>
        <p className="mt-2 text-xs text-gray-500">{description}</p>
      </div>
      <div className="rounded-full bg-indigo-100 p-3">
        {icon}
      </div>
    </div>
  </div>
);

const SEOMetrics = () => {
  const metrics = [
    {
      title: 'Palavras-chave',
      value: '1,245',
      change: '12.5%',
      isPositive: true,
      icon: <FaSearch className="h-6 w-6 text-indigo-600" />,
      description: 'Palavras-chave ranqueadas',
    },
    {
      title: 'Tráfego Orgânico',
      value: '8,743',
      change: '8.3%',
      isPositive: true,
      icon: <SiGoogleanalytics className="h-6 w-6 text-indigo-600" />,
      description: 'Visitas orgânicas/mês',
    },
    {
      title: 'Backlinks',
      value: '1,287',
      change: '5.2%',
      isPositive: true,
      icon: <FaLink className="h-6 w-6 text-indigo-600" />,
      description: 'Links de domínios únicos',
    },
    {
      title: 'Velocidade',
      value: '2.4s',
      change: '0.8s',
      isPositive: false,
      icon: <FaMobileAlt className="h-6 w-6 text-indigo-600" />,
      description: 'Tempo de carregamento',
    },
  ];

  return (
    <div className="space-y-6">
      <h2 className="text-lg font-medium text-gray-900">Métricas de SEO</h2>
      <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-4">
        {metrics.map((metric, index) => (
          <MetricCard key={index} {...metric} />
        ))}
      </div>
    </div>
  );
};

export default SEOMetrics;
